module.exports = __webpack_public_path__ + "img/service_transport.6f96204f.jpg";